import { IMedicationsStore } from './types';

const initStore: IMedicationsStore = {
  items: [],
  pagination: {
    page: null,
    itemsPerPage: null,
    hasMore: false,
  },
};

export default initStore;
